module.exports = __webpack_public_path__ + "static/assets/1a086f192347214d507e8373d05481bd.svg";